import React from "react";
import { styled } from "@mui/material/styles";
import { Tooltip, tooltipClasses } from "@mui/material";
import { SECONDARY_THEME_COLOR } from "../../../consts/colors";

const DarkTooltip = styled(({ className, backgroundColor, ...props }) => (
  <Tooltip {...props} classes={{ popper: className }} />
))(({ theme, backgroundColor, ...props }) => ({
  [`& .${tooltipClasses.tooltip}`]: {
    backgroundColor:SECONDARY_THEME_COLOR || theme.palette.common.black,
    fontSize: 14,
    ...(props.arrow && { paddingBottom: "6px",backgroundColor:SECONDARY_THEME_COLOR }),
  },
  [`& .${tooltipClasses.arrow}`]: {
    "&:before": {
      backgroundColor: backgroundColor || theme.palette.common.black,
    },
  },
}));

export default DarkTooltip;
